import type { environments } from "@dealer-center/core-enviroment";
import {
  type BridgeBarSettings,
  CoreBridgeBar
} from "@dealer-center/core-bridge-bar";
import { useSystemStore } from "@dealer-center/ddc-state-system";
import { useMemo } from "react";
import AddScriptTag from "./add-script-tag";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";

interface BridgeBarScriptProps {
  jwt: string;
  environment: environments;
  solutionGroup: string;
}

const getBridgeBarScript = ({
  jwt,
  environment,
  solutionGroup
}: BridgeBarScriptProps) => {
  const bridgeBarSettings: BridgeBarSettings = {
    solutionGroupCode: solutionGroup,
    sessionId: jwt,
    env: environment
  };

  return `var bbEl = document.querySelector('bridge-bar');bbEl.addEventListener('initialized',function(){bbEl.bb.render(${JSON.stringify(
    bridgeBarSettings
  )});});`;
};

export function BridgeBar() {
  const { enviroment } = useSystemStore();
  const { data: userEntity } = useGetUser();
  const bridgeScript = useMemo(() => {
    const config: BridgeBarScriptProps = {
      solutionGroup: "DDC",
      jwt: userEntity?.sessionId || "",
      environment: enviroment
    };

    return getBridgeBarScript(config);
  }, [enviroment, userEntity?.sessionId]);

  if (!userEntity || !userEntity.sessionId) return null;
  return (
    <>
      <CoreBridgeBar data-testid="bridge-bar" />
      <AddScriptTag
        async
        src="https://assets.bridge.coxautoservices.com/bridge-bar.js"
        testid="bridge-bar-script"
      />
      <AddScriptTag script={bridgeScript} testid="bridge-bar-inline-script" />
    </>
  );
}

export default BridgeBar;
